import { AxiosInstance } from "axios"
import { IOTP } from "."

export interface IOTPApi {
  generate: () => Promise<IOTP>
  validate: (token: string) => Promise<IOTP>
  verify: (token: string) => Promise<IOTP>
}

const otp = (axiosClient: AxiosInstance): IOTPApi => ({
  generate: async () => {
    const response = await axiosClient.post("/otp/generate/")
    return response.data
  },
  validate: async (token: string) => {
    const response = await axiosClient.post("/otp/validate/", { token })
    return response.data
  },
  verify: async (token: string) => {
    // withCredentials lets the browser store the CloudFront signed cookies
    // (view.scient.io access) set by the cross-origin API response
    const response = await axiosClient.post("/otp/verify/", { token }, { withCredentials: true })
    return response.data
  },
})

export default otp
